var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomLoadNextPage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 16v-1h9v1H1zm9.352-7.648L5.5 13.242.648 8.352l.704-.704L5 11.32V0h1v11.32l3.648-3.672.704.704z",
    fill: "currentColor"
  })));
}

export default SvgCustomLoadNextPage;